export default {
  email: 'Email',
  password: 'Senha',
  enter: 'Ingresar',
  emailIsRequired: 'E-mail no pode ser vazio',
  emailIsInvalid: 'E-mail no valido',
  passwordIsRequired: 'Senha no pode ser vazia',
  notFound: 'Usuario no encontrado',
  Unauthorized: 'Senha inválida',
  genericErrorMsg: 'Ops, no conseguimos fazer o login, tente novamente mas tarde.',
};
